import { ApplicationConfig, LOCALE_ID, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { provideNzI18n } from 'ng-zorro-antd/i18n';
import { es_ES } from 'ng-zorro-antd/i18n';
import {
  UploadOutline,
  FileTextOutline,
  EditOutline,
  DeleteOutline,
  InboxOutline,
  ArrowUpOutline,
  ArrowDownOutline,
  MinusOutline,
  DashboardOutline,
  BankOutline,
  FolderAddOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  FileOutline,
  FolderOpenOutline,
  CheckCircleOutline,
  SearchOutline,
  CloseOutline,
  SortAscendingOutline,
  SortDescendingOutline,
  DragOutline,
  FileExcelOutline,
  CalendarOutline,
  RiseOutline,
  FallOutline,
  FilterOutline,
  ReloadOutline,
  PlusOutline,
  UserOutline,
  LockOutline,
  EyeOutline,
  EyeInvisibleOutline,
  LogoutOutline,
  MenuOutline,
} from '@ant-design/icons-angular/icons';

import { routes } from './app.routes';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

const icons = [
  UploadOutline,
  FileTextOutline,
  EditOutline,
  DeleteOutline,
  InboxOutline,
  ArrowUpOutline,
  ArrowDownOutline,
  MinusOutline,
  DashboardOutline,
  BankOutline,
  FolderAddOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  FileOutline,
  FolderOpenOutline,
  CheckCircleOutline,
  SearchOutline,
  CloseOutline,
  SortAscendingOutline,
  SortDescendingOutline,
  DragOutline,
  FileExcelOutline,
  CalendarOutline,
  RiseOutline,
  FallOutline,
  FilterOutline,
  ReloadOutline,
  PlusOutline,
  UserOutline,
  LockOutline,
  EyeOutline,
  EyeInvisibleOutline,
  LogoutOutline,
  MenuOutline,
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideNzIcons(icons),
    { provide: LOCALE_ID, useValue: 'es-MX' },
    provideNzI18n(es_ES),
    provideCharts(withDefaultRegisterables()),
  ]
};
